module.exports = __webpack_public_path__ + "img/Restaurant15.154ae886.png";